function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.333 8.605l-.94-.938a.57.57 0 00-.805 0L12 16.229 3.412 7.667a.57.57 0 00-.806 0l-.939.938a.569.569 0 000 .806l9.93 9.922a.57.57 0 00.806 0l9.93-9.922a.569.569 0 000-.806z",
  fill: "#333",
  fillRule: "evenodd"
});

function SvgArrowCollapseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgArrowCollapseinline;